import { Link } from "react-router-dom";

export default function LandingPage() {
  return (
    <div className="landing">
      <nav className="landing-nav">
        <span className="brand">KPI Enterprise Mining</span>
        <div className="landing-nav-actions">
          <Link to="/login" className="btn ghost">Anmelden</Link>
          <Link to="/register" className="btn primary">Kostenlos starten</Link>
        </div>
      </nav>

      <section className="landing-hero">
        <span className="hero-eyebrow">C-Level Performance Operating System</span>
        <h1>
          <span className="mobile-line">Aus Ihren Daten</span> <span className="grad mobile-line">echte KPIs</span><span className="mobile-space"> </span><br className="desktop-break" />
          <span className="mobile-line">mit KI-Berater</span> <span className="mobile-line">an Ihrer Seite.</span>
        </h1>
        <p className="lead">
          Souveräne deutsche Plattform für Geschäftsführer und Beraterinnen.
          Anstatt erfundene Zahlen zu zeigen, fragen wir zuerst Ihr Unternehmen ab,
          recherchieren live im Hintergrund, schlagen passende KPIs vor — und Sie entscheiden.
        </p>
        <div className="hero-cta">
          <Link to="/register" className="btn primary big">Jetzt onboarden</Link>
          <Link to="/demo" className="btn ghost big">Demo erleben (Sandbox)</Link>
        </div>
        <p className="hero-trust muted small">
          DSGVO · EU AI Act Art. 12 (7y Audit-Trail) · Row-Level-Security · Multi-Tenant · NVIDIA DGX Spark
        </p>
      </section>

      <section className="landing-steps">
        <h2>So funktioniert es</h2>
        <ol className="steps-grid">
          <li>
            <div className="step-num">1</div>
            <strong>Registrieren</strong>
            <p>30 Sekunden — Email, Passwort, Firmenname.</p>
          </li>
          <li>
            <div className="step-num">2</div>
            <strong>Research läuft live</strong>
            <p>Während Sie tippen, recherchieren unsere Agenten Branche, Wettbewerber, Benchmark.</p>
          </li>
          <li>
            <div className="step-num">3</div>
            <strong>Antworten in Konversation</strong>
            <p>Persona, Ziele, Pain-Points — natürlich erfragt, nicht als Formular.</p>
          </li>
          <li>
            <div className="step-num">4</div>
            <strong>KPI-Vorschlag</strong>
            <p>Wir schlagen 5 maßgeschneiderte KPIs vor — Sie approven mit einem Klick.</p>
          </li>
          <li>
            <div className="step-num">5</div>
            <strong>Daten anschließen</strong>
            <p>CSV-Upload oder REST. Datenqualität geprüft (5 Dimensionen), erst dann erscheinen Werte.</p>
          </li>
          <li>
            <div className="step-num">6</div>
            <strong>Live arbeiten</strong>
            <p>Driver-Trees, KI-Berater immer 1 Klick weit, Briefings, Audit-Trail — alles in Echtzeit.</p>
          </li>
        </ol>
      </section>

      <section className="landing-pillars">
        <h2>Was uns anders macht</h2>
        <div className="pillars-grid">
          <article>
            <div className="pillar-icon">⊕</div>
            <h3>Onboarding-First</h3>
            <p>Niemals erfundene Zahlen. Wir zeigen erst KPIs, wenn Ihre Daten validiert sind.</p>
          </article>
          <article>
            <div className="pillar-icon">⌘</div>
            <h3>Live-Co-Working</h3>
            <p>Geschäftsführer und Beraterin sehen denselben Stream. Anomalien, Briefings, KI-Antworten — synchron.</p>
          </article>
          <article>
            <div className="pillar-icon">⚙</div>
            <h3>KI-Berater im Cockpit</h3>
            <p>4 Modi (KPIs, Use Cases, ROI, Strategie) × 12 Personas. Immer einen Tastendruck weit.</p>
          </article>
          <article>
            <div className="pillar-icon">▣</div>
            <h3>Driver-Trees interaktiv</h3>
            <p>Klicken Sie sich vom Outcome zum Hebel — KI-Berater übernimmt mit vollem Kontext.</p>
          </article>
          <article>
            <div className="pillar-icon">⌖</div>
            <h3>Datenqualität-Gate</h3>
            <p>5 Dimensionen, Spalten-Mapping per KI, Score &lt; 60 sperrt KPI-Anzeige.</p>
          </article>
          <article>
            <div className="pillar-icon">◉</div>
            <h3>EU AI Act ready</h3>
            <p>Jeder Agent-Run → 7y ClickHouse-Audit. Art. 12 ist nicht Compliance-Theater, sondern eingebaut.</p>
          </article>
        </div>
      </section>

      <section className="landing-cta-final">
        <h2>Bereit, echte KPIs zu sehen?</h2>
        <div className="hero-cta">
          <Link to="/register" className="btn primary big">Kostenlos onboarden</Link>
          <Link to="/demo" className="btn ghost big">Erst die Sandbox</Link>
        </div>
      </section>

      <footer className="landing-footer">
        <span className="muted small">
          ben-e-fit · medialine · ki-guru · vwfs.medialine.app · gehostet auf NVIDIA DGX Spark · DSGVO/EU AI Act ready
        </span>
      </footer>
    </div>
  );
}
